import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store/index";
import { Contractor } from "@/models/api/Contractor";
import Vue from "vue";
export interface UserPersistedDataStateInterface {
  recentlyUsedContractors: Record<string, Array<Contractor>>;
}

export const ContractorsState: UserPersistedDataStateInterface = {
  recentlyUsedContractors: {},
};

const UserPersistedDataModule = defineModule({
  state: ContractorsState as UserPersistedDataStateInterface,
  namespaced: true as const,
  getters: {
    recentlyUsedContractors:
      (...args) =>
      (sourceKey: string) => {
        const { state } = _moduleGetterContext(args);
        return state.recentlyUsedContractors[sourceKey] ?? [];
      },
  },
  mutations: {
    addContractorToRecentlyUsed(state, params: { key: string; contractor: Contractor }) {
      let contractors = state.recentlyUsedContractors[params.key] ?? []; // initialize when empty
      contractors = contractors.filter((x) => x.id != params.contractor.id);
      contractors = [params.contractor, ...contractors].slice(0, 5);
      Vue.set(state.recentlyUsedContractors, params.key, contractors);
    },
  },
  actions: {},
});

export default UserPersistedDataModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) => moduleGetterContext(args, UserPersistedDataModule);
const _moduleActionContext = (context: any) => moduleActionContext(context, UserPersistedDataModule);
